module.exports = __webpack_public_path__ + "static/media/pricing-card.105f38e3.JPG";